import { defineMessages } from '../define';

/** Add / edit expense and expense detail (DESIGN 4.10, 4.11). */
export const expenseMessages = defineMessages(
  {
    newExpense: 'New expense',
    editExpense: 'Edit expense',
    closeWithoutSaving: 'Close without saving',
    groupChip: 'Group: {name}. Change',
    chooseGroup: 'Choose a group',
    description: 'Description',
    whatFor: 'What was it for?',
    categoryButton: 'Category: {name}. Change',
    category: 'Category',
    cat_food: 'Food',
    cat_groceries: 'Groceries',
    cat_transport: 'Transport',
    cat_stay: 'Stay',
    cat_drinks: 'Drinks',
    cat_fun: 'Fun',
    cat_utilities: 'Utilities',
    cat_gifts: 'Gifts',
    cat_health: 'Health',
    cat_other: 'Other',
    amount: 'Amount',
    amountIn: 'Amount in {currency}',
    currencyChip: 'Currency: {name}. Change',
    convertedLine: '≈ {amount} · 1 {from} = {rate} {to}',
    rateSourceEcb: '(ECB, {date})',
    rateManual: '(manual)',
    editRate: 'Edit rate',
    rateTitle: 'Exchange rate',
    rateLabel: '1 {from} in {to}',
    rateHint: 'Saved on this expense so its value never changes.',
    useEcbRate: 'Use the ECB rate',
    rateInvalid: 'Enter a rate between 0.000000001 and 1,000,000,000 (up to 15 digits).',
    convertedTooLarge: 'The converted amount is too large. Check the rate.',
    rateUnavailable: 'Rate unavailable. Enter it to continue.',
    paidBy: 'Paid by',
    whoPaid: 'Who paid?',
    multiplePaid: 'Multiple people paid',
    onePersonPaid: 'One person paid',
    paidByMany: '{count} people',
    paidAmountFor: 'Amount paid by {name}',
    split: 'Split',
    splitMode: 'Split mode',
    modeEqual: '= Equal',
    modeExact: '1.23 Exact',
    modePercent: '% Percent',
    modeShares: '½ Shares',
    equally: 'Equally',
    exact: 'Exact',
    percent: 'Percent',
    shares: 'Shares',
    splitChip: '{mode} · {count}',
    totalLabel: '{amount} total',
    left: '{amount} left',
    over: '{amount} too much',
    percentLeft: '{value}% left',
    percentOver: '{value}% too much',
    allAssigned: 'All assigned',
    needParticipant: 'Choose at least one person.',
    needShares: 'Give at least one person a share.',
    invalidShares: 'Use whole or half shares, like 1 or 1.5.',
    invalidPercent: 'Use percentages with up to 2 decimals.',
    centFootnote: '1 cent is added to the first participants.',
    shareOf: 'Shares for {name}',
    percentOf: 'Percent for {name}',
    amountFor: 'Amount for {name}',
    includeMember: 'Include {name}',
    sharesUnit: '{count, plural, one {# share} other {# shares}}',
    date: 'Date',
    note: 'Note',
    notePlaceholder: 'Add a note',
    receipt: 'Receipt',
    takePhoto: 'Take photo',
    chooseLibrary: 'Choose from library',
    removeReceipt: 'Remove receipt',
    receiptProcessing: 'Preparing photo…',
    receiptFailed: "Couldn't read that photo.",
    receiptTooLarge: 'That photo is too large. Choose one under {max} MB.',
    receiptWrongType: "That file type isn't supported. Choose a JPEG, PNG, WebP or HEIC photo.",
    receiptReplacesPending:
      'This expense already has a photo waiting to upload. A new photo will replace it.',
    eachPays: 'Each person pays',
    whoPays: 'Who pays what',
    preview: 'Split preview',
    options: 'Expense options',
    saveExpense: 'Save expense',
    saveChanges: 'Save changes',
    deleteExpense: 'Delete expense',
    discardTitle: 'Discard this expense?',
    discardChanges: 'Discard your changes?',
    discardBody: "What you entered won't be saved.",
    discard: 'Discard',
    keepEditing: 'Keep editing',
    expenseAdded: 'Expense added',
    expenseUpdated: 'Changes saved',
    expenseDeleted: 'Expense deleted',
    amountRequired: 'Enter an amount greater than 0.',
    payersMismatch: "What people paid doesn't add up to the total.",
    splitInvalid: "The split doesn't add up. Open Split to fix it.",
    versionConflict:
      'Someone else changed this expense. Close it and open it again to see their changes.',
    versionConflictQueued:
      'Your offline changes to “{title}” were not saved: someone else changed it first.',
    queuedEditFailed: 'Your offline changes to “{title}” were not saved.',
    leftMembersChanged:
      'This change would alter the balance of people who left the group: {names}.',
    queuedEditRetryable: "Your offline changes to “{title}” couldn't be saved yet.",
    photoDiscarded: 'The photo you attached was not saved either.',
    failedEdit: "Your offline changes to this expense couldn't be saved.",
    queuedDeleteFailed: "An expense you deleted couldn't be deleted. Try again.",
    leftMembersDelete:
      "Couldn't delete {hasTitle, select, yes {“{title}”} other {an expense}}: it would change the balance of {names}, who left the group. Add them back to the group first.",
    leftMembersRestore:
      "Couldn't restore {hasTitle, select, yes {“{title}”} other {an expense}}: it would change the balance of {names}, who left the group. Add them back to the group first.",
    receiptUploadFailed:
      "A receipt photo couldn't be uploaded yet. Split will try again next time you open it.",
    receiptRejectedTooLarge:
      "The receipt photo {hasTitle, select, yes {for “{title}”} other {for an expense}} wasn't saved: it's larger than {max} MB.",
    receiptRejectedType:
      "The receipt photo {hasTitle, select, yes {for “{title}”} other {for an expense}} wasn't saved: that type of image isn't supported (use JPEG, PNG, WebP or HEIC).",
    receiptRejected:
      "The receipt photo {hasTitle, select, yes {for “{title}”} other {for an expense}} couldn't be saved.",
    noGroups: 'Create a group first to add expenses.',
    // Detail
    splitEqualBetween: 'Split equally between {count}',
    splitExactBetween: 'Split by exact amounts',
    splitPercentBetween: 'Split by percentages',
    splitSharesBetween: 'Split by shares',
    addedBy: 'Added by {name}',
    convertedAt: '≈ {amount} at 1 {from} = {rate} {to} {source}',
    history: 'History',
    historyCreated: '{name} added this expense',
    historyEdited: '{name} edited {field}',
    historyEditedMany: '{name} edited {count} things',
    historyDeleted: '{name} deleted this expense',
    historyRestored: '{name} restored this expense',
    field_amount: 'the amount',
    field_title: 'the description',
    field_date: 'the date',
    field_category: 'the category',
    field_note: 'the note',
    field_payers: 'who paid',
    field_split: 'the split',
    field_fx: 'the exchange rate',
    field_receipt: 'the receipt',
    field_other: 'the expense',
    fieldName_amount: 'Amount',
    fieldName_title: 'Description',
    fieldName_date: 'Date',
    fieldName_category: 'Category',
    fieldName_note: 'Note',
    fieldName_payers: 'Paid by',
    fieldName_split: 'Split',
    fieldName_fx: 'Exchange rate',
    fieldName_receipt: 'Receipt',
    fieldName_other: 'Other',
    showChanges: 'Show changes',
    hideChanges: 'Hide changes',
    changed: 'changed',
    empty: 'empty',
    deletedBanner: 'This expense was deleted by {name}',
    restore: 'Restore',
    restored: 'Expense restored',
    deleted: 'Deleted',
    copyAsNew: 'Copy as new',
    moreActions: 'More actions',
    receiptAlt: 'Receipt photo',
    openReceipt: 'Open receipt',
    someone: 'Someone',
    loadError: "Couldn't load this expense.",
    paidAmount: '{name} paid {amount}',
  },
  {
    newExpense: 'Nuevo gasto',
    editExpense: 'Editar gasto',
    closeWithoutSaving: 'Cerrar sin guardar',
    groupChip: 'Grupo: {name}. Cambiar',
    chooseGroup: 'Elige un grupo',
    description: 'Descripción',
    whatFor: '¿Para qué fue?',
    categoryButton: 'Categoría: {name}. Cambiar',
    category: 'Categoría',
    cat_food: 'Comida',
    cat_groceries: 'Compra',
    cat_transport: 'Transporte',
    cat_stay: 'Alojamiento',
    cat_drinks: 'Bebidas',
    cat_fun: 'Ocio',
    cat_utilities: 'Suministros',
    cat_gifts: 'Regalos',
    cat_health: 'Salud',
    cat_other: 'Otros',
    amount: 'Importe',
    amountIn: 'Importe en {currency}',
    currencyChip: 'Moneda: {name}. Cambiar',
    convertedLine: '≈ {amount} · 1 {from} = {rate} {to}',
    rateSourceEcb: '(BCE, {date})',
    rateManual: '(manual)',
    editRate: 'Editar tipo',
    rateTitle: 'Tipo de cambio',
    rateLabel: '1 {from} en {to}',
    rateHint: 'Se guarda en este gasto para que su valor no cambie.',
    useEcbRate: 'Usar el tipo del BCE',
    rateInvalid: 'Introduce un tipo entre 0,000000001 y 1.000.000.000 (hasta 15 cifras).',
    convertedTooLarge: 'El importe convertido es demasiado grande. Revisa el tipo.',
    rateUnavailable: 'Tipo no disponible. Introdúcelo para continuar.',
    paidBy: 'Pagó',
    whoPaid: '¿Quién pagó?',
    multiplePaid: 'Pagaron varias personas',
    onePersonPaid: 'Pagó una persona',
    paidByMany: '{count} personas',
    paidAmountFor: 'Importe pagado por {name}',
    split: 'Dividir',
    splitMode: 'Modo de división',
    modeEqual: '= Iguales',
    modeExact: '1,23 Exacto',
    modePercent: '% Porcentaje',
    modeShares: '½ Partes',
    equally: 'A partes iguales',
    exact: 'Exacto',
    percent: 'Porcentaje',
    shares: 'Partes',
    splitChip: '{mode} · {count}',
    totalLabel: '{amount} en total',
    left: 'Faltan {amount}',
    over: 'Sobran {amount}',
    percentLeft: 'Falta un {value} %',
    percentOver: 'Sobra un {value} %',
    allAssigned: 'Todo asignado',
    needParticipant: 'Elige al menos una persona.',
    needShares: 'Da al menos una parte a alguien.',
    invalidShares: 'Usa partes enteras o medias, como 1 o 1,5.',
    invalidPercent: 'Usa porcentajes con hasta 2 decimales.',
    centFootnote: 'Se añade 1 céntimo a los primeros participantes.',
    shareOf: 'Partes de {name}',
    percentOf: 'Porcentaje de {name}',
    amountFor: 'Importe de {name}',
    includeMember: 'Incluir a {name}',
    sharesUnit: '{count, plural, one {# parte} other {# partes}}',
    date: 'Fecha',
    note: 'Nota',
    notePlaceholder: 'Añade una nota',
    receipt: 'Recibo',
    takePhoto: 'Hacer foto',
    chooseLibrary: 'Elegir de la galería',
    removeReceipt: 'Quitar recibo',
    receiptProcessing: 'Preparando la foto…',
    receiptFailed: 'No se pudo leer esa foto.',
    receiptTooLarge: 'Esa foto es demasiado grande. Elige una de menos de {max} MB.',
    receiptWrongType: 'Ese tipo de archivo no se admite. Elige una foto JPEG, PNG, WebP o HEIC.',
    receiptReplacesPending:
      'Este gasto ya tiene una foto pendiente de subir. Una foto nueva la sustituirá.',
    eachPays: 'Cada persona paga',
    whoPays: 'Quién paga qué',
    preview: 'Vista previa del reparto',
    options: 'Opciones del gasto',
    saveExpense: 'Guardar gasto',
    saveChanges: 'Guardar cambios',
    deleteExpense: 'Eliminar gasto',
    discardTitle: '¿Descartar este gasto?',
    discardChanges: '¿Descartar los cambios?',
    discardBody: 'Lo que has escrito no se guardará.',
    discard: 'Descartar',
    keepEditing: 'Seguir editando',
    expenseAdded: 'Gasto añadido',
    expenseUpdated: 'Cambios guardados',
    expenseDeleted: 'Gasto eliminado',
    amountRequired: 'Introduce un importe mayor que 0.',
    payersMismatch: 'Lo que pagó cada uno no suma el total.',
    splitInvalid: 'La división no cuadra. Abre Dividir para corregirla.',
    versionConflict:
      'Otra persona cambió este gasto. Ciérralo y vuelve a abrirlo para ver sus cambios.',
    versionConflictQueued:
      'Tus cambios sin conexión en «{title}» no se guardaron: otra persona lo cambió antes.',
    queuedEditFailed: 'Tus cambios sin conexión en «{title}» no se guardaron.',
    leftMembersChanged:
      'Este cambio alteraría el saldo de personas que salieron del grupo: {names}.',
    queuedEditRetryable: 'Aún no se pudieron guardar tus cambios sin conexión en «{title}».',
    photoDiscarded: 'La foto que adjuntaste tampoco se guardó.',
    failedEdit: 'No se pudieron guardar tus cambios sin conexión en este gasto.',
    queuedDeleteFailed: 'Un gasto que eliminaste no se pudo eliminar. Inténtalo de nuevo.',
    leftMembersDelete:
      'No se pudo eliminar {hasTitle, select, yes {«{title}»} other {un gasto}}: cambiaría el saldo de {names}, que salieron del grupo. Vuelve a añadirlos al grupo primero.',
    leftMembersRestore:
      'No se pudo restaurar {hasTitle, select, yes {«{title}»} other {un gasto}}: cambiaría el saldo de {names}, que salieron del grupo. Vuelve a añadirlos al grupo primero.',
    receiptUploadFailed:
      'Aún no se pudo subir la foto de un recibo. Split lo volverá a intentar la próxima vez que lo abras.',
    receiptRejectedTooLarge:
      'La foto del recibo {hasTitle, select, yes {de «{title}»} other {de un gasto}} no se guardó: ocupa más de {max} MB.',
    receiptRejectedType:
      'La foto del recibo {hasTitle, select, yes {de «{title}»} other {de un gasto}} no se guardó: ese tipo de imagen no se admite (usa JPEG, PNG, WebP o HEIC).',
    receiptRejected:
      'La foto del recibo {hasTitle, select, yes {de «{title}»} other {de un gasto}} no se pudo guardar.',
    noGroups: 'Crea primero un grupo para añadir gastos.',
    splitEqualBetween: 'A partes iguales entre {count}',
    splitExactBetween: 'Dividido por importes exactos',
    splitPercentBetween: 'Dividido por porcentajes',
    splitSharesBetween: 'Dividido por partes',
    addedBy: 'Añadido por {name}',
    convertedAt: '≈ {amount} a 1 {from} = {rate} {to} {source}',
    history: 'Historial',
    historyCreated: '{name} añadió este gasto',
    historyEdited: '{name} cambió {field}',
    historyEditedMany: '{name} cambió {count} cosas',
    historyDeleted: '{name} eliminó este gasto',
    historyRestored: '{name} restauró este gasto',
    field_amount: 'el importe',
    field_title: 'la descripción',
    field_date: 'la fecha',
    field_category: 'la categoría',
    field_note: 'la nota',
    field_payers: 'quién pagó',
    field_split: 'la división',
    field_fx: 'el tipo de cambio',
    field_receipt: 'el recibo',
    field_other: 'el gasto',
    fieldName_amount: 'Importe',
    fieldName_title: 'Descripción',
    fieldName_date: 'Fecha',
    fieldName_category: 'Categoría',
    fieldName_note: 'Nota',
    fieldName_payers: 'Pagó',
    fieldName_split: 'División',
    fieldName_fx: 'Tipo de cambio',
    fieldName_receipt: 'Recibo',
    fieldName_other: 'Otro',
    showChanges: 'Ver cambios',
    hideChanges: 'Ocultar cambios',
    changed: 'cambiado',
    empty: 'vacío',
    deletedBanner: 'Este gasto lo eliminó {name}',
    restore: 'Restaurar',
    restored: 'Gasto restaurado',
    deleted: 'Eliminado',
    copyAsNew: 'Copiar como nuevo',
    moreActions: 'Más acciones',
    receiptAlt: 'Foto del recibo',
    openReceipt: 'Abrir recibo',
    someone: 'Alguien',
    loadError: 'No se pudo cargar este gasto.',
    paidAmount: '{name} pagó {amount}',
  },
);
